import {
  AvailableMembershipPlan, HoldingPaidMembershipPlan,
  NotEverSubscribedPaidMembershipPlan,
  ReservedPaidMembershipPlan,
  SubscribedPaidMembershipPlan,
  UnsubscribedPaidMembershipPlan,
} from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { AvailablePaidMembershipPlanScheme } from '@/models/api/paid-member-price/member-plan/scheme'

export function convertPlan(p: AvailablePaidMembershipPlanScheme): AvailableMembershipPlan {
  if (p.holding) {
    return new HoldingPaidMembershipPlan(p)
  }
  if (p.reserved) {
    return new ReservedPaidMembershipPlan(p)
  }
  if (!p.subscribed && !p.unsubscribed) {
    return new NotEverSubscribedPaidMembershipPlan(p)
  }
  if (p.unsubscribed) {
    /**
     * @see BasePaidMemberPlan.active
     */
    return new UnsubscribedPaidMembershipPlan(p)
  }

  return new SubscribedPaidMembershipPlan(p)
}
